// ============================================================
// URL ベースの言語判定マーカー
// LangShop は Shopify ネイティブの locale を使わないため、サーバーが付与する
// <html lang>（request.locale.iso_code 由来）が「表示中の言語」と一致しない。
// そこで表示中 URL（/ = 英語 / /ja = 日本語）を正とし、
// <html data-url-lang="en|ja"> を付与する。これを CSS の en-only/ja-only や
// フッターの自動挿入リンクの文言切替の基準にする（html[lang] から移行）。
// ============================================================
(function () {
  "use strict";

  function isJapaneseUrl() {
    var path = window.location.pathname;
    // /jacket 等の誤一致を避けるため "/ja" 完全一致 or "/ja/" prefix のみ日本語扱い
    return path === "/ja" || path.indexOf("/ja/") === 0;
  }

  // 他スクリプト（クッキー設定・Do Not Sell リンク等）からも参照できるよう公開
  window.isJapaneseUrl = isJapaneseUrl;

  function applyUrlLang() {
    document.documentElement.setAttribute(
      "data-url-lang",
      isJapaneseUrl() ? "ja" : "en"
    );
  }

  // 即時適用（custom.js は defer 読み込みのため body パース後の早い段階で付与される）
  applyUrlLang();

  // SPA 的なページ遷移後にも追従
  document.addEventListener("theme:loading:end", applyUrlLang);
  window.addEventListener("popstate", applyUrlLang);
})();

// ブラウザ標準のフォーム検証吹き出しを使わず、入力欄下に検証エラーを表示する
(function () {
  "use strict";

  var localizedValidationFlag = "localizedValidationMessage";

  function getValidationLang() {
    // このテーマでは LangShop の都合で html[lang] と表示言語がズレるため、
    // URL から付けた data-url-lang を優先する。無い場合だけ html[lang] を使う。
    var urlLang = document.documentElement.getAttribute("data-url-lang");
    if (urlLang === "en" || urlLang === "ja") return urlLang;

    var htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    if (htmlLang.indexOf("en") === 0) return "en";
    if (htmlLang.indexOf("ja") === 0) return "ja";

    return "ja";
  }

  function isEnglishValidationLang() {
    return getValidationLang() === "en";
  }

  function escapeAttributeValue(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return CSS.escape(value);
    }

    return String(value).replace(/"/g, '\\"');
  }

  function getFieldLabel(field) {
    if (field.labels && field.labels.length > 0) {
      var associatedLabel = Array.prototype.find.call(field.labels, function (label) {
        return label.textContent.trim();
      });

      if (associatedLabel) return associatedLabel.textContent.trim();
    }

    if (field.id) {
      var label = document.querySelector('label[for="' + escapeAttributeValue(field.id) + '"]');
      if (label && label.textContent.trim()) return label.textContent.trim();
    }

    var ariaLabel = field.getAttribute("aria-label");
    if (ariaLabel && ariaLabel.trim()) return ariaLabel.trim();

    var placeholder = field.getAttribute("placeholder");
    if (placeholder && placeholder.trim()) return placeholder.trim();

    return "";
  }

  function getEnglishValidationMessage(field) {
    var validity = field.validity;
    var tagName = field.tagName.toLowerCase();
    var type = (field.getAttribute("type") || "").toLowerCase();

    if (validity.valueMissing) {
      if (tagName === "select" || type === "radio") return "Please select an option.";

      if (type === "checkbox") {
        return /privacy policy|プライバシーポリシー/i.test(getFieldLabel(field))
          ? "You must agree to the Privacy Policy."
          : "Please check this box to continue.";
      }

      return "Please fill out this field.";
    }

    if (validity.typeMismatch) {
      if (type === "email") return "Please enter a valid email address.";
      if (type === "url") return "Please enter a valid URL.";

      return "Please enter a valid value.";
    }

    if (validity.tooShort && field.minLength > 0) {
      return "Please enter at least " + field.minLength + " characters.";
    }

    if (validity.tooLong && field.maxLength > 0) {
      return "Please enter no more than " + field.maxLength + " characters.";
    }

    if (validity.rangeUnderflow && field.min) {
      return "Please enter a value greater than or equal to " + field.min + ".";
    }

    if (validity.rangeOverflow && field.max) {
      return "Please enter a value less than or equal to " + field.max + ".";
    }

    if (validity.patternMismatch) {
      return "Please match the requested format.";
    }

    if (validity.stepMismatch || validity.badInput) {
      return "Please enter a valid value.";
    }

    return "";
  }

  function getJapaneseValidationMessage(field) {
    var validity = field.validity;
    var tagName = field.tagName.toLowerCase();
    var type = (field.getAttribute("type") || "").toLowerCase();

    if (validity.valueMissing) {
      if (tagName === "select" || type === "radio") return "選択してください。";

      if (type === "checkbox") {
        return /privacy policy|プライバシーポリシー/i.test(getFieldLabel(field))
          ? "プライバシーポリシーへの同意が必要です"
          : "チェックしてください。";
      }

      return "入力してください。";
    }

    if (validity.typeMismatch) {
      if (type === "email") return "有効なメールアドレスを入力してください。";
      if (type === "url") return "有効なURLを入力してください。";

      return "有効な値を入力してください。";
    }

    if (validity.tooShort && field.minLength > 0) {
      return field.minLength + "文字以上で入力してください。";
    }

    if (validity.tooLong && field.maxLength > 0) {
      return field.maxLength + "文字以内で入力してください。";
    }

    if (validity.rangeUnderflow && field.min) {
      return field.min + "以上の値を入力してください。";
    }

    if (validity.rangeOverflow && field.max) {
      return field.max + "以下の値を入力してください。";
    }

    if (validity.patternMismatch) {
      return "指定された形式で入力してください。";
    }

    if (validity.stepMismatch || validity.badInput) {
      return "有効な値を入力してください。";
    }

    return "";
  }

  function getLocalizedValidationMessage(field) {
    if (!field || !field.validity || field.validity.valid) return "";

    if (field.validity.customError && field.dataset[localizedValidationFlag] !== "true" && field.validationMessage) {
      return field.validationMessage;
    }

    return isEnglishValidationLang() ? getEnglishValidationMessage(field) : getJapaneseValidationMessage(field);
  }

  function clearLocalizedValidationMessage(field) {
    if (!field || typeof field.setCustomValidity !== "function" || !field.dataset) return;

    if (field.dataset[localizedValidationFlag] === "true") {
      field.setCustomValidity("");
      delete field.dataset[localizedValidationFlag];
    }
  }

  function getInlineErrorElement(field) {
    if (!field || typeof field.closest !== "function") return null;

    var formControl = field.closest(".form-control");
    if (formControl) {
      return formControl.querySelector(".form-control__error-message");
    }

    var checkboxControl = field.closest(".checkbox-control");
    if (checkboxControl) {
      return checkboxControl.querySelector(".checkbox-control__error-message");
    }

    return null;
  }

  function showInlineValidationMessage(field, message) {
    if (!field || !field.validity) return;

    if (!message) {
      clearLocalizedValidationMessage(field);
      message = getLocalizedValidationMessage(field);
    }

    if (!message) {
      clearInlineValidationMessage(field);
      return;
    }

    var errorElement = getInlineErrorElement(field);
    if (!errorElement) return;

    errorElement.textContent = message;
    field.setAttribute("aria-invalid", "true");

    var control = field.closest(".form-control, .checkbox-control");
    if (control) control.classList.add("is-invalid");
  }

  function clearInlineValidationMessage(field) {
    if (!field || typeof field.closest !== "function") return;

    clearLocalizedValidationMessage(field);

    var errorElement = getInlineErrorElement(field);
    if (errorElement) errorElement.textContent = "";

    field.removeAttribute("aria-invalid");

    var control = field.closest(".form-control, .checkbox-control");
    if (control) control.classList.remove("is-invalid");
  }

  function updateValidationMessage(field) {
    if (!field || typeof field.setCustomValidity !== "function" || !field.validity) return;

    clearLocalizedValidationMessage(field);

    if (!isEnglishValidationLang()) return;

    var message = getEnglishValidationMessage(field);
    if (message) {
      field.setCustomValidity(message);
      field.dataset[localizedValidationFlag] = "true";
    }
  }

  function showFormValidationMessages(form) {
    if (!form || typeof form.querySelectorAll !== "function") return;

    form.querySelectorAll("input, select, textarea").forEach(function (field) {
      if (field.willValidate && !field.validity.valid) {
        showInlineValidationMessage(field);
      } else {
        clearInlineValidationMessage(field);
      }
    });
  }

  function prepareFormValidationMessages(form) {
    if (!form || typeof form.querySelectorAll !== "function") return;

    form.querySelectorAll("input, select, textarea").forEach(function (field) {
      updateValidationMessage(field);
    });
  }

  document.addEventListener("click", function (event) {
    var submitter = event.target && event.target.closest ? event.target.closest('button[type="submit"], input[type="submit"], button:not([type])') : null;
    if (!submitter) return;

    var form = submitter.form || submitter.closest("form");
    prepareFormValidationMessages(form);
  }, true);

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter") return;
    if (!event.target || !event.target.form) return;

    prepareFormValidationMessages(event.target.form);
  }, true);

  document.addEventListener("invalid", function (event) {
    event.preventDefault();
    updateValidationMessage(event.target);
    showInlineValidationMessage(event.target);
  }, true);

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || form.noValidate) return;

    prepareFormValidationMessages(form);

    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      showFormValidationMessages(form);

      var firstInvalidField = form.querySelector("input:invalid, select:invalid, textarea:invalid");
      if (firstInvalidField && typeof firstInvalidField.focus === "function") {
        firstInvalidField.focus();
      }
    }
  }, true);

  document.addEventListener("input", function (event) {
    clearInlineValidationMessage(event.target);
  });

  document.addEventListener("change", function (event) {
    clearInlineValidationMessage(event.target);
  });

  window.getLocalizedRequiredCheckboxMessage = function () {
    return isEnglishValidationLang() ? "You must agree to the Privacy Policy." : "プライバシーポリシーへの同意が必要です";
  };

  window.showInlineValidationMessage = showInlineValidationMessage;
  window.clearInlineValidationMessage = clearInlineValidationMessage;
})();

// Policy titles
(function () {
  "use strict";

  function updatePolicyTitle() {
    var path = window.location.pathname.replace(/\/$/, "");
    var titles = {
      "/policies/terms-of-service": "Terms of Use",
      "/policies/legal-notice": "Legal Notices",
      "/policies/refund-policy": "Return & Refund",
      "/policies/shipping-policy": "Shipping"
    };

    if (!titles[path]) return;

    var title = document.querySelector(".shopify-policy__title h1");
    if (title) {
      title.textContent = titles[path];
    }

    if (path === "/policies/refund-policy" && title) {
      var titleWrapper = title.closest(".shopify-policy__title");
      if (titleWrapper) {
        titleWrapper.classList.add("c-policy-title--refund");
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updatePolicyTitle);
  } else {
    updatePolicyTitle();
  }
})();

// カラースウォッチ切り替え後のセカンダリ画像更新を確実にする
(function () {
  "use strict";

  // createMediaImg関数を取得（theme.jsからエクスポートされている場合）
  let createMediaImg = null;
  if (typeof window.createMediaImg === "function") {
    createMediaImg = window.createMediaImg;
  }

  function updateProductCardSoldOut(productCard) {
    const soldOutElements = productCard.querySelectorAll("[data-product-card-sold-out]");

    if (!soldOutElements.length) {
      return;
    }

    const selectedSwatch = productCard.querySelector('.product-card__info [type="radio"]:checked[data-variant-available]');

    if (!selectedSwatch) {
      return;
    }

    soldOutElements.forEach(function (soldOutElement) {
      soldOutElement.hidden = selectedSwatch.dataset.variantAvailable !== "false";
    });
  }

  function enhanceProductCardSwatchBehavior() {
    document.querySelectorAll("product-card").forEach(function (productCard) {
      updateProductCardSoldOut(productCard);

      // 既にイベントリスナーが追加されているかチェック
      if (productCard.dataset.swatchEnhanced === "true") {
        return;
      }
      productCard.dataset.swatchEnhanced = "true";

      // カラースウォッチ変更時のイベントリスナー
      // 既存のchangeイベントの後に実行されるように、少し遅延させる
      productCard.addEventListener(
        "change",
        function (event) {
          if (event.target.type === "radio" && event.target.closest(".product-card__info")) {
            setTimeout(function () {
              const target = event.target;
              const secondaryMediaElement = productCard.querySelector(".product-card__image--secondary");
              const primaryMediaElement = productCard.querySelector(".product-card__image--primary");
              const mediaCarousel = productCard.querySelector(".product-card__media-carousel");

              updateProductCardSoldOut(productCard);

              if (target.hasAttribute("data-variant-media") && mediaCarousel && typeof mediaCarousel.select === "function") {
                try {
                  const variantMedia = JSON.parse(target.getAttribute("data-variant-media"));
                  const variantMediaId = variantMedia && variantMedia.id ? String(variantMedia.id) : "";
                  const matchingSlideIndex = variantMediaId
                    ? mediaCarousel.cells.findIndex(function (slide) {
                      return slide.dataset.mediaId === variantMediaId;
                    })
                    : -1;

                  mediaCarousel.select(matchingSlideIndex >= 0 ? matchingSlideIndex : 0, { instant: true });
                } catch (e) {
                  mediaCarousel.select(0, { instant: true });
                }
              }

              // セカンダリメディアが存在し、data-variant-secondary-media属性がない場合
              if (secondaryMediaElement && primaryMediaElement && !target.hasAttribute("data-variant-secondary-media")) {
                // バリアントのメディア情報を取得
                if (target.hasAttribute("data-variant-media")) {
                  try {
                    const variantMedia = JSON.parse(target.getAttribute("data-variant-media"));

                    // バリアントのメディア配列から次のメディアを取得する必要があるが、
                    // これはサーバー側で設定する必要があるため、option-value.liquidで適切に設定されていることを確認してください
                    // ここでは、セカンダリメディアが存在する場合、それを維持するだけです

                    // セカンダリメディアが存在しない場合、プライマリメディアと同じものを使用
                    // これは一時的な解決策で、option-value.liquidで適切に設定されるまで使用されます
                  } catch (e) {
                    console.error("Error parsing variant media:", e);
                  }
                }
              }
            }, 100);
          }
        },
        true
      ); // キャプチャフェーズで実行して、既存のイベントハンドラーの前に実行
    });
  }

  // DOMContentLoadedイベントで実行
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      // ProductCardのカスタム要素が定義されるまで待つ
      if (customElements.get("product-card")) {
        enhanceProductCardSwatchBehavior();
      } else {
        // カスタム要素がまだ定義されていない場合、定義されるまで待つ
        const observer = new MutationObserver(function (mutations, obs) {
          if (customElements.get("product-card")) {
            obs.disconnect();
            enhanceProductCardSwatchBehavior();
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    });
  } else {
    // 既にDOMContentLoadedが発火している場合
    if (customElements.get("product-card")) {
      enhanceProductCardSwatchBehavior();
    }
  }
})();

// PC 商品カード: hover で 2 枚目を表示し、左右矢印で画像カルーセルを操作する
(function () {
  "use strict";

  const mediaQuery = window.matchMedia("(min-width: 1000px) and (pointer: fine)");

  function getHoverProductCard(event) {
    const productCard = event.target.closest("product-card");

    if (!productCard || productCard.contains(event.relatedTarget)) {
      return null;
    }

    const carousel = productCard.querySelector(".product-card__media-carousel");

    if (
      !carousel ||
      !carousel.cells ||
      carousel.cells.length < 2 ||
      carousel.scrollWidth <= carousel.clientWidth + 1
    ) {
      return null;
    }

    return { productCard, carousel };
  }

  document.addEventListener("pointerover", function (event) {
    if (!mediaQuery.matches) {
      return;
    }

    const target = getHoverProductCard(event);

    if (
      !target ||
      target.productCard.dataset.hoverCarouselActive === "true" ||
      target.carousel.selectedIndex !== 0
    ) {
      return;
    }

    target.productCard.dataset.hoverCarouselActive = "true";
    target.carousel.select(1, { instant: true });
  });

  document.addEventListener("pointerout", function (event) {
    if (!mediaQuery.matches) {
      return;
    }

    const target = getHoverProductCard(event);

    if (!target) {
      return;
    }

    target.productCard.dataset.hoverCarouselActive = "false";
    // custom: ホバーを離したらカルーセルを1枚目に戻す
    target.carousel.select(0, { instant: true });
  });
})();

// フィルタードロワー: CLEARボタンのクリックイベント
document.addEventListener("DOMContentLoaded", function () {
  // Applyボタンにチェック済みフィルター数を表示
  function updateApplyButtonCount() {
    const drawer = document.querySelector("facets-drawer");
    if (!drawer) return;

    // チェック済みのチェックボックスをカウント（在庫ありのみ表示は除外）
    const checkedCheckboxes = drawer.querySelectorAll('input[type="checkbox"]:checked:not([name="filter.v.availability"])');
    const count = checkedCheckboxes.length;

    // Applyボタンを探す
    const applyButton = drawer.querySelector('dialog-close-button button, [slot="footer"] button:not(.c-facets-drawer__clear-button)');
    if (applyButton) {
      // 現在のテキストから既存のカウントを削除
      let baseText = applyButton.textContent.trim();
      baseText = baseText.replace(/\s*\(\d+\)\s*$/, "");

      // テキストが変更される場合のみ更新（無限ループを防ぐ）
      const newText = count > 0 ? baseText + " (" + count + ")" : baseText;
      if (applyButton.textContent.trim() !== newText) {
        applyButton.textContent = newText;
      }
    }
  }

  function initApplyButtonCount() {
    const drawer = document.querySelector("facets-drawer");
    if (!drawer) return;

    // 既に初期化済みの場合はスキップ
    if (drawer.dataset.applyButtonCountInitialized === "true") {
      return;
    }
    drawer.dataset.applyButtonCountInitialized = "true";

    // 初期カウントを更新
    updateApplyButtonCount();

    // チェックボックスの変更を監視（既にリスナーが追加されているものはスキップ）
    drawer.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
      if (checkbox.dataset.countListenerAttached === "true") {
        return;
      }
      checkbox.dataset.countListenerAttached = "true";
      checkbox.addEventListener("change", function () {
        updateApplyButtonCount();
      });
    });
  }

  function initDrawerClearButtons() {
    const drawerClearButtons = document.querySelectorAll(".c-facets-drawer__clear-button");

    drawerClearButtons.forEach(function (clearButton) {
      // 既にイベントリスナーが設定されている場合はスキップ
      if (clearButton.dataset.listenerAttached === "true") {
        return;
      }

      clearButton.dataset.listenerAttached = "true";
      clearButton.addEventListener("click", function () {
        // フィルター選択状態をリセット
        resetDrawerFilters();

        // カウントを更新
        updateApplyButtonCount();

        // 非同期でフィルターをクリア
        clearDrawerFilters();
      });
    });
  }

  function resetDrawerFilters() {
    // フィルターフォーム内のすべてのチェックボックスを解除
    const drawer = document.querySelector("facets-drawer");
    if (drawer) {
      drawer.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
        checkbox.checked = false;
      });

      // フィルターフォーム内のすべてのラジオボタンを解除
      drawer.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.checked = false;
      });

      // 価格範囲をリセット
      drawer.querySelectorAll('input[type="range"]').forEach(function (range) {
        const min = parseFloat(range.min);
        const max = parseFloat(range.max);
        if (range.getAttribute("aria-label") === "から") {
          range.value = min;
        } else if (range.getAttribute("aria-label") === "まで") {
          range.value = max;
        }
      });

      // 価格入力フィールドをリセット
      drawer.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]').forEach(function (input) {
        input.value = "";
      });
    }
  }

  function clearDrawerFilters() {
    // 現在のページタイプを判定
    const isSearchPage = document.querySelector(".main-search__resource-item") !== null;
    const isCollectionPage = document.querySelector(".collection__main") !== null;

    if (isSearchPage) {
      // 検索ページの場合
      const urlParams = new URLSearchParams(window.location.search);
      const searchQuery = urlParams.get("q");

      if (searchQuery) {
        const cleanUrl = window.location.origin + window.location.pathname + "?q=" + encodeURIComponent(searchQuery) + "&type=product";
        if (typeof fetchSearchProducts === "function") {
          fetchSearchProducts(cleanUrl).then(function (html) {
            if (html) {
              if (typeof updateSearchList === "function") {
                updateSearchList(html);
              }
              // drawerを閉じる
              const drawer = document.querySelector("facets-drawer");
              if (drawer) {
                drawer.removeAttribute("open");
              }
            }
          });
        } else {
          // fetchSearchProductsが存在しない場合は、通常のリロード
          window.location.href = cleanUrl;
        }
      } else {
        const cleanUrl = window.location.origin + window.location.pathname;
        if (typeof fetchSearchProducts === "function") {
          fetchSearchProducts(cleanUrl).then(function (html) {
            if (html) {
              if (typeof updateSearchList === "function") {
                updateSearchList(html);
              }
              const drawer = document.querySelector("facets-drawer");
              if (drawer) {
                drawer.removeAttribute("open");
              }
            }
          });
        } else {
          window.location.href = cleanUrl;
        }
      }
    } else if (isCollectionPage) {
      // コレクションページの場合
      const collectionUrl = window.location.origin + window.location.pathname;
      if (typeof fetchCollectionProducts === "function") {
        fetchCollectionProducts(collectionUrl).then(function (html) {
          if (html) {
            if (typeof updateCollectionList === "function") {
              updateCollectionList(html);
            }
            // drawerを閉じる
            const drawer = document.querySelector("facets-drawer");
            if (drawer) {
              drawer.removeAttribute("open");
            }
          }
        });
      } else {
        window.location.href = collectionUrl;
      }
    }
  }

  // 初期化
  initDrawerClearButtons();
  initApplyButtonCount();

  // 動的に追加される要素にも対応（facets-drawerが追加された時のみ）
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Element node
          // facets-drawerが追加された場合のみ初期化
          if (node.tagName === "FACETS-DRAWER" || node.querySelector("facets-drawer")) {
            setTimeout(function () {
              initDrawerClearButtons();
              initApplyButtonCount();
            }, 100);
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

/*
  ヘッダードロップダウン専用コントローラ。
  通常メニュー / メガメニュー / 白背景 / 50%白オーバーレイを同じタイミングで開閉する。
*/
document.addEventListener("DOMContentLoaded", function () {
  function initHeaderMenuDisclosureController() {
    if (window.__headerMenuDisclosureControllerPatched) {
      return;
    }

    const timeline = window.__vendor_timeline;
    if (typeof timeline !== "function") {
      setTimeout(initHeaderMenuDisclosureController, 50);
      return;
    }

    const DropdownMenuDisclosure = window.customElements.get("dropdown-menu-disclosure");
    const MegaMenuDisclosure = window.customElements.get("mega-menu-disclosure");

    if (!DropdownMenuDisclosure || !MegaMenuDisclosure) {
      Promise.all([
        window.customElements.whenDefined("dropdown-menu-disclosure"),
        window.customElements.whenDefined("mega-menu-disclosure"),
      ]).then(initHeaderMenuDisclosureController);
      return;
    }

    window.__headerMenuDisclosureControllerPatched = true;

    const originalDropdownShow = DropdownMenuDisclosure.prototype.createShowAnimationControls;
    const originalDropdownHide = DropdownMenuDisclosure.prototype.createHideAnimationControls;
    const originalMegaShow = MegaMenuDisclosure.prototype.createShowAnimationControls;
    const originalMegaHide = MegaMenuDisclosure.prototype.createHideAnimationControls;
    const DURATION = 0.32;
    const BG_DURATION = 0.34;
    // メニュー（bgLayer）が下り切る = BG_DURATION 後。オーバーレイはその直後（間を空けず）に開始。
    const OVERLAY_SHOW_DELAY = BG_DURATION;
    // クライアント指示: オーバーレイの 0→最大 にかかる時間を従来 0.82s の約半分に高速化。
    const OVERLAY_SHOW_DURATION = 0.41;
    const OVERLAY_HIDE_DURATION = 0.22;
    const TEXT_HIDE_DURATION = 0.12;
    const SWITCH_TEXT_SHOW_DELAY = 0.06;
    const SWITCH_TEXT_SHOW_DURATION = 0.2;
    const EASING = [0.25, 0.1, 0.25, 1];
    const state = { generation: 0 };

    function cancelRunningAnimations(target) {
      try {
        if (!target || typeof target.getAnimations !== "function") return;
        target.getAnimations().forEach(function (anim) {
          if (anim && typeof anim.cancel === "function") {
            if (typeof anim.commitStyles === "function") {
              try {
                anim.commitStyles();
              } catch (e) {
                // no-op
              }
            }
            anim.cancel();
          }
        });
      } catch (e) {
        // no-op
      }
    }

    function getHeaderSection(disclosure) {
      return (disclosure && disclosure.closest && disclosure.closest(".shopify-section--header")) || document.querySelector(".shopify-section--header");
    }

    function isPrimaryHeaderDisclosure(disclosure) {
      return Boolean(
        disclosure &&
          disclosure.parentElement &&
          disclosure.parentElement.classList.contains("header__primary-nav-item") &&
          disclosure.closest(".shopify-section--header")
      );
    }

    // SP（max-width: 999px）はドロップダウン非対応のため、白背景レイヤーは作らない
    function isSmallViewport() {
      return window.matchMedia("(max-width: 999px)").matches;
    }

    function getOrCreateLayer(headerSection, className) {
      if (!headerSection) return null;

      const existing = headerSection.querySelector("." + className);
      if (isSmallViewport()) {
        if (existing) existing.remove();
        return null;
      }

      if (existing) return existing;

      const layer = document.createElement("div");
      layer.className = className;
      headerSection.appendChild(layer);
      return layer;
    }

    function getOrCreatePageOverlay() {
      const existing = document.body.querySelector(":scope > .c-header-menu-page-overlay");
      if (isSmallViewport()) {
        if (existing) existing.remove();
        return null;
      }

      if (existing) return existing;

      const layer = document.createElement("div");
      layer.className = "c-header-menu-page-overlay";
      document.body.appendChild(layer);
      return layer;
    }

    function ensureLayers(headerSection) {
      return {
        bgLayer: getOrCreateLayer(headerSection, "c-header-dropdown-bg"),
        overlayLayer: getOrCreatePageOverlay(),
      };
    }

    function hasActiveHeaderDisclosure(headerSection) {
      if (!headerSection) return false;

      return headerSection.querySelectorAll(
        ".header__primary-nav-item > dropdown-menu-disclosure > details.header__menu-disclosure[aria-expanded='true'], " +
          ".header__primary-nav-item > mega-menu-disclosure > details.header__menu-disclosure[aria-expanded='true']"
      ).length > 0;
    }

    function getCurrentOpacity(element) {
      if (!element) return 0;
      return parseFloat(window.getComputedStyle(element).opacity) || 0;
    }

    function getCurrentHeight(element) {
      if (!element) return 0;
      return element.getBoundingClientRect().height || 0;
    }

    function getHeaderHeight(headerSection) {
      if (!headerSection) return 0;

      const header = headerSection.querySelector(".header");
      return Math.ceil((header || headerSection).getBoundingClientRect().height || 0);
    }

    function getChromeTargetHeight(headerSection, contentHeight) {
      return getHeaderHeight(headerSection) + Math.max(0, Math.ceil(contentHeight || 0));
    }

    function getTargetHeight(element) {
      if (!element) return 0;

      const previousMaxHeight = element.style.maxHeight;
      element.style.maxHeight = "";
      const height = Math.ceil(element.getBoundingClientRect().height || element.scrollHeight || element.offsetHeight || 0);
      element.style.maxHeight = previousMaxHeight;

      return height;
    }

    function prepareContent(contentElement) {
      if (!contentElement) return;

      contentElement.style.opacity = "1";
      contentElement.style.transform = "none";
      contentElement.querySelectorAll(":scope > li, .mega-menu__linklist > li, .mega-menu__promo").forEach(function (element) {
        element.style.opacity = "1";
        element.style.transform = "none";
      });
    }

    function getMenuContentItems(contentElement) {
      if (!contentElement) return [];

      return Array.from(contentElement.querySelectorAll(":scope > li, .mega-menu__linklist > li, .mega-menu__promo"));
    }

    function revealChrome(headerSection, bgLayer, overlayLayer) {
      if (headerSection) {
        headerSection.classList.add("c-header-menu-is-open");
      }

      if (bgLayer) {
        bgLayer.dataset.revealed = "true";
        bgLayer.style.visibility = "visible";
      }

      if (overlayLayer) {
        overlayLayer.dataset.revealed = "true";
        overlayLayer.style.visibility = "visible";
        document.documentElement.classList.add("c-header-layer-is-open");
      }
    }

    function hideChrome(headerSection, bgLayer, overlayLayer, generation) {
      if (state.generation !== generation || hasActiveHeaderDisclosure(headerSection)) {
        return;
      }

      if (headerSection) {
        headerSection.classList.remove("c-header-menu-is-open");
      }

      if (bgLayer) {
        bgLayer.dataset.revealed = "false";
        bgLayer.style.height = "0px";
        bgLayer.style.visibility = "hidden";
      }

      if (overlayLayer) {
        overlayLayer.dataset.revealed = "false";
        overlayLayer.style.opacity = "0";
        overlayLayer.style.visibility = "hidden";
        document.documentElement.classList.remove("c-header-layer-is-open");
      }
    }

    function animateChrome(bgLayer, overlayLayer, targetHeight, targetOpacity, generation, headerSection) {
      const animations = [];

      cancelRunningAnimations(bgLayer);
      cancelRunningAnimations(overlayLayer);

      if (bgLayer) {
        const baseHeight = targetHeight > 0 ? getHeaderHeight(headerSection) : 0;
        const fromHeight = Math.max(getCurrentHeight(bgLayer), baseHeight);
        bgLayer.style.height = fromHeight + "px";
        animations.push([
          bgLayer,
          { height: [fromHeight + "px", targetHeight + "px"] },
          { duration: BG_DURATION, easing: EASING },
        ]);
      }

      if (overlayLayer) {
        const fromOpacity = getCurrentOpacity(overlayLayer);
        const isShowing = targetOpacity > fromOpacity;
        animations.push([
          overlayLayer,
          { opacity: [fromOpacity, targetOpacity] },
          {
            duration: isShowing ? OVERLAY_SHOW_DURATION : OVERLAY_HIDE_DURATION,
            easing: EASING,
            at: isShowing ? OVERLAY_SHOW_DELAY : "<",
          },
        ]);
      }

      if (animations.length === 0) {
        return null;
      }

      const controls = timeline(animations);
      controls.finished.catch(function () {
        return null;
      });

      return controls;
    }

    function createInstantControls() {
      return {
        finished: Promise.resolve({}),
        finish: function () {},
      };
    }

    function forceDesktopHoverTrigger(headerSection) {
      if (!headerSection) return;

      headerSection.querySelectorAll(".header__primary-nav-item > dropdown-menu-disclosure, .header__primary-nav-item > mega-menu-disclosure").forEach(function (disclosure) {
        disclosure.setAttribute("trigger", "hover");
      });
    }

    function getPrimaryHeaderDisclosures(headerSection) {
      if (!headerSection) return [];

      return Array.from(headerSection.querySelectorAll(".header__primary-nav-item > dropdown-menu-disclosure, .header__primary-nav-item > mega-menu-disclosure")).filter(isPrimaryHeaderDisclosure);
    }

    function isDisclosureOpen(disclosure) {
      return Boolean(disclosure && disclosure.disclosureElement && disclosure.disclosureElement.getAttribute("aria-expanded") === "true");
    }

    function getOpenPrimaryHeaderDisclosures(headerSection) {
      return getPrimaryHeaderDisclosures(headerSection).filter(isDisclosureOpen);
    }

    function hasOtherActiveHeaderDisclosure(headerSection, currentDisclosure) {
      return getOpenPrimaryHeaderDisclosures(headerSection).some(function (disclosure) {
        return disclosure !== currentDisclosure;
      });
    }

    function suppressOtherHeaderMenuContent(headerSection, currentDisclosure) {
      getOpenPrimaryHeaderDisclosures(headerSection).forEach(function (disclosure) {
        if (disclosure === currentDisclosure || !disclosure.contentElement) return;

        const contentElement = disclosure.contentElement;

        cancelRunningAnimations(contentElement);
        getMenuContentItems(contentElement).forEach(function (element) {
          cancelRunningAnimations(element);
          element.style.opacity = "0";
          element.style.transform = "translateY(-4px)";
        });

        contentElement.style.overflow = "hidden";
        contentElement.style.maxHeight = "0px";
        disclosure.__headerMenuIsClosing = false;
      });
    }

    function refreshActiveHeaderMenuLayouts() {
      if (isSmallViewport()) return;

      document.querySelectorAll(".shopify-section--header").forEach(function (headerSection) {
        const activeDisclosures = getPrimaryHeaderDisclosures(headerSection).filter(isDisclosureOpen);

        if (activeDisclosures.length === 0) {
          return;
        }

        const layers = ensureLayers(headerSection);
        let targetHeight = 0;

        activeDisclosures.forEach(function (disclosure) {
          const contentElement = disclosure.contentElement;
          if (!contentElement) return;

          cancelRunningAnimations(contentElement);
          prepareContent(contentElement);

          contentElement.style.maxHeight = "";
          contentElement.style.overflow = "";
          targetHeight = Math.max(targetHeight, getTargetHeight(contentElement));
        });

        revealChrome(headerSection, layers.bgLayer, layers.overlayLayer);

        if (layers.bgLayer) {
          cancelRunningAnimations(layers.bgLayer);
          layers.bgLayer.dataset.revealed = "true";
          layers.bgLayer.style.visibility = "visible";
          layers.bgLayer.style.height = getChromeTargetHeight(headerSection, targetHeight) + "px";
        }
      });
    }

    let headerMenuLayoutRefreshFrame = null;
    let headerMenuLayoutDelayedRefreshTimer = null;

    function scheduleHeaderMenuLayoutRefresh(delay) {
      if (isSmallViewport()) return;

      if (delay && delay > 0) {
        clearTimeout(headerMenuLayoutDelayedRefreshTimer);
        headerMenuLayoutDelayedRefreshTimer = setTimeout(function () {
          scheduleHeaderMenuLayoutRefresh(0);
        }, delay);
        return;
      }

      if (headerMenuLayoutRefreshFrame) {
        return;
      }

      headerMenuLayoutRefreshFrame = requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          headerMenuLayoutRefreshFrame = null;
          refreshActiveHeaderMenuLayouts();
        });
      });
    }

    function bindHeaderMenuLayoutObserver(headerSection) {
      if (!headerSection || headerSection.__headerMenuLayoutObserverBound) return;

      headerSection.__headerMenuLayoutObserverBound = true;

      const observer = new MutationObserver(function () {
        if (!hasActiveHeaderDisclosure(headerSection)) return;

        scheduleHeaderMenuLayoutRefresh(0);
        scheduleHeaderMenuLayoutRefresh(120);
      });

      observer.observe(headerSection, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    function bindHeaderMenuLayoutObservers() {
      document.querySelectorAll(".shopify-section--header").forEach(bindHeaderMenuLayoutObserver);
    }

    function createShowControls(disclosure) {
      const contentElement = disclosure.contentElement;
      const headerSection = getHeaderSection(disclosure);
      const layers = ensureLayers(headerSection);
      const isSwitchingMenu = hasOtherActiveHeaderDisclosure(headerSection, disclosure);
      const generation = ++state.generation;

      if (!contentElement) {
        revealChrome(headerSection, layers.bgLayer, layers.overlayLayer);
        animateChrome(layers.bgLayer, layers.overlayLayer, getChromeTargetHeight(headerSection, 0), 1, generation, headerSection);
        return createInstantControls();
      }

      forceDesktopHoverTrigger(headerSection);
      revealChrome(headerSection, layers.bgLayer, layers.overlayLayer);
      cancelRunningAnimations(contentElement);
      prepareContent(contentElement);

      const targetHeight = getTargetHeight(contentElement);
      const targetChromeHeight = getChromeTargetHeight(headerSection, targetHeight);
      const fromHeight = disclosure.__headerMenuIsClosing ? getCurrentHeight(contentElement) : 0;

      disclosure.__headerMenuIsClosing = false;

      if (isSwitchingMenu) {
        const menuItems = getMenuContentItems(contentElement);

        suppressOtherHeaderMenuContent(headerSection, disclosure);

        contentElement.style.overflow = "hidden";
        contentElement.style.maxHeight = targetHeight + "px";

        menuItems.forEach(function (element) {
          element.style.opacity = "0";
          element.style.transform = "translateY(6px)";
        });

        animateChrome(layers.bgLayer, layers.overlayLayer, targetChromeHeight, 1, generation, headerSection);

        const controls = timeline([
          [
            menuItems.length ? menuItems : contentElement,
            { opacity: [0, 1], transform: ["translateY(6px)", "translateY(0)"] },
            { duration: SWITCH_TEXT_SHOW_DURATION, easing: EASING, at: SWITCH_TEXT_SHOW_DELAY },
          ],
        ]);

        controls.finished.then(function () {
          if (state.generation !== generation || disclosure.disclosureElement.getAttribute("aria-expanded") !== "true") {
            return;
          }

          contentElement.style.maxHeight = "";
          contentElement.style.overflow = "";
          prepareContent(contentElement);
          refreshActiveHeaderMenuLayouts();
        }).catch(function () {
          return null;
        });

        return controls;
      }

      if (contentElement) {
        contentElement.style.overflow = "hidden";
        contentElement.style.maxHeight = fromHeight + "px";
      }

      animateChrome(layers.bgLayer, layers.overlayLayer, targetChromeHeight, 1, generation, headerSection);

      const controls = timeline([
        [
          contentElement,
          { maxHeight: [fromHeight + "px", targetHeight + "px"] },
          { duration: DURATION, easing: EASING },
        ],
      ]);

      controls.finished.then(function () {
        if (state.generation !== generation || disclosure.disclosureElement.getAttribute("aria-expanded") !== "true") {
          return;
        }
        contentElement.style.maxHeight = "";
        contentElement.style.overflow = "";
        refreshActiveHeaderMenuLayouts();
      }).catch(function () {
        return null;
      });

      return controls;
    }

    function createHideControls(disclosure) {
      const contentElement = disclosure.contentElement;
      const headerSection = getHeaderSection(disclosure);
      const layers = ensureLayers(headerSection);
      const isSwitchingMenu = hasOtherActiveHeaderDisclosure(headerSection, disclosure);
      const generation = isSwitchingMenu ? state.generation : ++state.generation;

      if (!contentElement) {
        if (!isSwitchingMenu) {
          animateChrome(layers.bgLayer, layers.overlayLayer, 0, 0, generation, headerSection);
        }
        return createInstantControls();
      }

      disclosure.__headerMenuIsClosing = true;
      cancelRunningAnimations(contentElement);

      if (isSwitchingMenu) {
        getMenuContentItems(contentElement).forEach(function (element) {
          cancelRunningAnimations(element);
          element.style.opacity = "0";
          element.style.transform = "translateY(-4px)";
        });

        contentElement.style.maxHeight = "0px";
        contentElement.style.overflow = "hidden";
        disclosure.__headerMenuIsClosing = false;

        return createInstantControls();
      }

      const fromHeight = Math.ceil(getCurrentHeight(contentElement) || contentElement.scrollHeight || contentElement.offsetHeight || 0);

      prepareContent(contentElement);

      if (contentElement) {
        contentElement.style.overflow = "hidden";
        contentElement.style.maxHeight = fromHeight + "px";
      }

      animateChrome(layers.bgLayer, layers.overlayLayer, 0, 0, generation, headerSection);

      const controls = timeline([
        [
          getMenuContentItems(contentElement),
          { opacity: [1, 0] },
          { duration: TEXT_HIDE_DURATION, easing: EASING },
        ],
        [
          contentElement,
          { maxHeight: [fromHeight + "px", "0px"] },
          { duration: DURATION, easing: EASING, at: "<" },
        ],
      ]);

      controls.finished.then(function () {
        if (disclosure.disclosureElement.getAttribute("aria-expanded") !== "true") {
          contentElement.style.maxHeight = "0px";
          contentElement.style.overflow = "hidden";
          disclosure.__headerMenuIsClosing = false;
        }

        hideChrome(headerSection, layers.bgLayer, layers.overlayLayer, generation);
      }).catch(function () {
        return null;
      });

      return controls;
    }

    DropdownMenuDisclosure.prototype.createShowAnimationControls = function () {
      if (!isPrimaryHeaderDisclosure(this)) {
        return originalDropdownShow.call(this);
      }

      return createShowControls(this);
    };

    DropdownMenuDisclosure.prototype.createHideAnimationControls = function () {
      if (!isPrimaryHeaderDisclosure(this)) {
        return originalDropdownHide.call(this);
      }

      return createHideControls(this);
    };

    MegaMenuDisclosure.prototype.createShowAnimationControls = function () {
      if (!isPrimaryHeaderDisclosure(this)) {
        return originalMegaShow.call(this);
      }

      return createShowControls(this);
    };

    MegaMenuDisclosure.prototype.createHideAnimationControls = function () {
      if (!isPrimaryHeaderDisclosure(this)) {
        return originalMegaHide.call(this);
      }

      return createHideControls(this);
    };
    ensureLayers(document.querySelector(".shopify-section--header"));
    forceDesktopHoverTrigger(document.querySelector(".shopify-section--header"));
    bindHeaderMenuLayoutObservers();

    document.addEventListener("theme:loading:end", function () {
      bindHeaderMenuLayoutObservers();
      scheduleHeaderMenuLayoutRefresh(120);
    });

    document.addEventListener("shopify:section:load", function () {
      bindHeaderMenuLayoutObservers();
      forceDesktopHoverTrigger(document.querySelector(".shopify-section--header"));
      scheduleHeaderMenuLayoutRefresh(120);
    });

    window.addEventListener("popstate", function () {
      scheduleHeaderMenuLayoutRefresh(120);
    });
  }

  window.__initHeaderMenuDisclosureController = initHeaderMenuDisclosureController;
  initHeaderMenuDisclosureController();
});

// バリエーション切り替え時にsizeセレクターのスタイルを維持
document.addEventListener("DOMContentLoaded", function () {
  function applySizeSelectStyles() {
    const sizeSelects = document.querySelectorAll(".c-product-info__size .select");
    if (!sizeSelects || sizeSelects.length === 0) {
      return;
    }

    sizeSelects.forEach(function (select) {
      if (!select) {
        return;
      }
      select.style.border = "none";
      // 0.25px だと subpixel rendering で灰色に見えるため 1px の真っ黒線にする
      select.style.boxShadow = "inset 0 -1px 0 0 #000000";

      // max-width 699pxのときは10px、それ以外は17px
      if (window.innerWidth <= 699) {
        select.style.paddingInlineStart = "10px";
      } else {
        select.style.paddingInlineStart = "17px";
      }
    });
  }

  // 初期適用
  applySizeSelectStyles();

  // ウィンドウリサイズ時にも再適用
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      applySizeSelectStyles();
    }, 100);
  });

  // product:rerenderイベントをリッスンして再適用
  document.addEventListener("product:rerender", function () {
    // 再レンダリング後に少し遅延させて適用
    setTimeout(function () {
      applySizeSelectStyles();
    }, 0);
  });

  // variant:changeイベントでも再適用（念のため）
  document.addEventListener("variant:change", function () {
    setTimeout(function () {
      applySizeSelectStyles();
    }, 0);
  });
});

// カスタムアコーディオンの開閉機能
document.addEventListener("DOMContentLoaded", function () {
  function initCustomAccordion() {
    const accordionToggles = document.querySelectorAll(".c-acordion__toggle");

    accordionToggles.forEach(function (toggle) {
      // 既にイベントリスナーが追加されている場合はスキップ
      if (toggle.dataset.listenerAttached === "true") {
        return;
      }
      toggle.dataset.listenerAttached = "true";

      toggle.addEventListener("click", function () {
        // トグルボタンにis-activeクラスを追加/削除
        toggle.classList.toggle("is-active");

        // 次のコンテンツ要素を取得
        const content = toggle.nextElementSibling;
        if (content && content.classList.contains("c-acordion__content")) {
          // コンテンツにis-openクラスを追加/削除
          content.classList.toggle("is-open");
        }
      });
    });
  }

  // 初期化
  initCustomAccordion();

  // 動的に追加される要素にも対応
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // カスタムアコーディオンが追加された場合
          if ((node.classList && node.classList.contains("product-form__custom-acordion")) || (node.querySelector && node.querySelector(".product-form__custom-acordion"))) {
            setTimeout(function () {
              initCustomAccordion();
            }, 100);
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // product:rerenderイベントでも再初期化
  document.addEventListener("product:rerender", function () {
    setTimeout(function () {
      initCustomAccordion();
    }, 100);
  });
});

// カンマ区切りテキストからテーブルを生成
document.addEventListener("DOMContentLoaded", function () {
  function generateTableFromCSV(container) {
    // 既に処理済みの場合はスキップ
    if (container.dataset.tableGenerated === "true") {
      return;
    }
    container.dataset.tableGenerated = "true";

    const text = container.textContent.trim();
    if (!text) {
      return;
    }

    // 改行で分割
    const rows = text.split(/\r?\n/).filter(function (row) {
      return row.trim() !== "";
    });

    if (rows.length === 0) {
      return;
    }

    // 各行をカンマで分割して、最大列数を取得
    let maxColumns = 0;
    const parsedRows = rows.map(function (row) {
      const columns = row.split(",").map(function (col) {
        return col.trim();
      });
      if (columns.length > maxColumns) {
        maxColumns = columns.length;
      }
      return columns;
    });

    // テーブルを生成
    const tableWrapper = document.createElement("div");
    tableWrapper.className = "c-acordion__table--size";
    tableWrapper.setAttribute("data-simplebar", "");

    const table = document.createElement("table");
    table.className = "c-acordion__table";
    const tbody = document.createElement("tbody");

    // スタイルは custom.css（.c-acordion__table--size）側で一括管理する。
    // 以前はここで border / width / font を !important のインラインで付与していたが、
    // CSS から調整できなくなる（インライン !important が最強）ため撤去した。
    parsedRows.forEach(function (columns) {
      const tr = document.createElement("tr");

      for (let i = 0; i < maxColumns; i++) {
        const cellValue = columns[i] || "";
        if (i === 0) {
          // 最初の列は th（見出し＝サイズ系統のラベル列）
          const th = document.createElement("th");
          th.textContent = cellValue;
          th.className = "c-font-bold";
          tr.appendChild(th);
        } else {
          // それ以外は td（中央寄せ）
          const td = document.createElement("td");
          td.className = "text-center";
          td.textContent = cellValue;
          tr.appendChild(td);
        }
      }
      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    tableWrapper.appendChild(table);

    // コンテナの内容を置き換え
    container.innerHTML = "";
    container.appendChild(tableWrapper);

    // Simplebarを初期化（Simplebarが読み込まれている場合）
    // autoHide: false でスクロール可能時にバーを常時表示（hover しなくても見える）
    if (typeof SimpleBar !== "undefined" && tableWrapper.querySelector("[data-simplebar]")) {
      new SimpleBar(tableWrapper, { autoHide: false });
    }
  }

  function initTableGenerators() {
    // サイズガイドとメジャーメントのコンテナを検索
    const sizeGuideContainers = document.querySelectorAll(".c-product-info__size-guide");
    const measurementsContainers = document.querySelectorAll(".c-product-info__product-measurements");

    sizeGuideContainers.forEach(function (container) {
      generateTableFromCSV(container);
    });

    measurementsContainers.forEach(function (container) {
      generateTableFromCSV(container);
    });
  }

  // 初期化
  initTableGenerators();

  // 動的に追加される要素にも対応
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // サイズガイドやメジャーメントのコンテナが追加された場合
          const sizeGuide = node.querySelector && node.querySelector(".c-product-info__size-guide");
          const measurements = node.querySelector && node.querySelector(".c-product-info__product-measurements");
          if (sizeGuide || measurements || node.classList.contains("c-product-info__size-guide") || node.classList.contains("c-product-info__product-measurements")) {
            setTimeout(function () {
              initTableGenerators();
            }, 100);
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // product:rerenderイベントでも再初期化
  document.addEventListener("product:rerender", function () {
    setTimeout(function () {
      initTableGenerators();
    }, 100);
  });
});

// 商品ギャラリーのプログレスバー進捗更新機能
// カルーセルのスクロール位置に応じてプログレスバーの進捗を更新
// 商品ギャラリーのプログレスバー進捗更新
(function () {
  "use strict";

  function updateProgressBar(carouselNavigation) {
    if (!carouselNavigation) return;

    // スマホ時のみ処理
    if (window.innerWidth > 999) return;

    // 現在アクティブなボタンを取得
    const activeButton = carouselNavigation.querySelector('button[aria-current="true"]');
    if (!activeButton) return;

    // すべてのボタンを取得（hiddenでないもののみ）
    const allButtons = Array.from(carouselNavigation.querySelectorAll("button:not([hidden])"));
    const activeIndex = allButtons.indexOf(activeButton);
    const totalCount = allButtons.length;

    if (totalCount === 0) return;

    // プログレスバーの最大幅（108px）を枚数で分割
    const maxWidth = 108;
    const progressWidth = (maxWidth / totalCount) * (activeIndex + 1);

    // CSS変数で進捗幅を設定（px単位）
    carouselNavigation.style.setProperty("--c-progress-width", progressWidth + "px");
  }

  function initProgressBars() {
    const progressBars = document.querySelectorAll(".product-gallery carousel-navigation.page-dots");

    progressBars.forEach(function (progressBar) {
      // 既に初期化済みの場合はスキップ
      if (progressBar.dataset.progressInitialized === "true") {
        return;
      }
      progressBar.dataset.progressInitialized = "true";

      // 初期進捗を設定
      updateProgressBar(progressBar);

      // aria-current属性の変更を監視して進捗を更新
      const mutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === "attributes" && mutation.attributeName === "aria-current") {
            updateProgressBar(progressBar);
          }
        });
      });

      // すべてのボタンのaria-current属性を監視
      const buttons = progressBar.querySelectorAll("button");
      buttons.forEach(function (button) {
        mutationObserver.observe(button, {
          attributes: true,
          attributeFilter: ["aria-current"],
        });
      });

      // カルーセルのスクロールも監視（スムーズスクロール時の補完）
      const carouselId = progressBar.getAttribute("aria-controls");
      if (carouselId) {
        const carousel = document.getElementById(carouselId);
        if (carousel) {
          // scrollイベントで進捗を更新
          carousel.addEventListener("scroll", function () {
            updateProgressBar(progressBar);
          });
        }
      }
    });
  }

  // DOMContentLoadedで初期化
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initProgressBars();
    });
  } else {
    initProgressBars();
  }

  // 動的に追加される要素にも対応
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // carousel-navigationが追加された場合
          if (node.tagName === "CAROUSEL-NAVIGATION" || (node.querySelector && node.querySelector("carousel-navigation.page-dots"))) {
            setTimeout(function () {
              initProgressBars();
            }, 100);
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // ウィンドウリサイズ時にも再初期化
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initProgressBars();
    }, 100);
  });
})();

// フッターのニュースレターフォーム: プライバシーポリシー同意チェックボックスのバリデーション
// @footer.liquid (113-125)
// プライバシーポリシー同意チェックボックスにチェックを入れなければ、メール登録ができないようにする
document.addEventListener("DOMContentLoaded", function () {
  function initFooterNewsletterValidation() {
    // フッター内のニュースレターフォームを取得
    const footerNewsletterForms = document.querySelectorAll(".footer form[id^='newsletter-form-']");

    footerNewsletterForms.forEach(function (form) {
      // 既にイベントリスナーが追加されている場合はスキップ
      if (form.dataset.validationInitialized === "true") {
        return;
      }
      form.dataset.validationInitialized = "true";

      // フォーム送信時のバリデーション
      form.addEventListener("submit", function (event) {
        // プライバシーポリシー同意チェックボックスを取得
        const privacyCheckbox = form.querySelector('input[name="contact[accepts_marketing]"][type="checkbox"]');

        if (privacyCheckbox && !privacyCheckbox.checked) {
          // チェックボックスがチェックされていない場合は送信を阻止
          event.preventDefault();
          event.stopPropagation();

          // チェックボックスにフォーカスを当てる
          privacyCheckbox.focus();

          // エラーメッセージを表示（既存のエラーバナーがあれば削除）
          const existingBanner = form.querySelector(".banner--error");
          if (existingBanner) {
            existingBanner.remove();
          }

          // エラーメッセージを表示
          const errorMessage = typeof window.getLocalizedRequiredCheckboxMessage === "function" ? window.getLocalizedRequiredCheckboxMessage() : "プライバシーポリシーへの同意が必要です";

          // チェックボックス下にエラー文言を表示
          privacyCheckbox.setCustomValidity(errorMessage);
          if (typeof window.showInlineValidationMessage === "function") {
            window.showInlineValidationMessage(privacyCheckbox, errorMessage);
          }

          return false;
        }
      });

      // チェックボックスがチェックされたら、エラーメッセージをクリア
      const privacyCheckbox = form.querySelector('input[name="contact[accepts_marketing]"][type="checkbox"]');
      if (privacyCheckbox) {
        privacyCheckbox.addEventListener("change", function () {
          if (this.checked) {
            // エラーバナーを削除
            const errorBanner = form.querySelector(".banner--error");
            if (errorBanner) {
              errorBanner.remove();
            }
            // カスタムバリデーションメッセージをクリア
            this.setCustomValidity("");
            if (typeof window.clearInlineValidationMessage === "function") {
              window.clearInlineValidationMessage(this);
            }
          }
        });
      }
    });
  }

  // 初期化
  initFooterNewsletterValidation();

  // 動的に追加される要素にも対応
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // フッターのニュースレターフォームが追加された場合
          if ((node.classList && node.classList.contains("footer")) || (node.querySelector && node.querySelector(".footer form[id^='newsletter-form-']"))) {
            setTimeout(function () {
              initFooterNewsletterValidation();
            }, 100);
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

// ページ遷移時にスクロール位置を最上部にリセット
// @custom.js (730-830)
// ページ遷移後は必ずページ最上部から表示するようにする
(function () {
  "use strict";

  // ブラウザのスクロール復元を無効化（ページ遷移時に常に先頭を表示）
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  // ページ遷移フラグ（グローバルスコープで共有）
  window._isPageTransition = false;

  function triggerFooterAdjustAfterTransition() {
    if (typeof window.adjustFooterPadding !== "function") {
      return;
    }
    setTimeout(function () {
      window.adjustFooterPadding();
    }, 100);
  }

  // theme:loading:endイベント（テーマのページ遷移後）
  document.addEventListener("theme:loading:end", function () {
    window._isPageTransition = true;
    // フッターの調整が完了するまで待ってからスクロール位置をリセット
    // adjustFooterPadding()内でスクロール位置がリセットされる
    triggerFooterAdjustAfterTransition();
  });

  // pageshowイベント（ブラウザの戻る/進むボタンなど）
  window.addEventListener("pageshow", function (event) {
    // persistedがtrueの場合はbfcacheからの復元、falseの場合は通常遷移
    // どちらもページ遷移として扱い、必ず先頭へ戻す
    window._isPageTransition = true;
    // adjustFooterPadding()内でスクロール位置がリセットされる
    triggerFooterAdjustAfterTransition();
  });

  // popstateイベント（ブラウザの戻る/進むボタン）
  window.addEventListener("popstate", function () {
    window._isPageTransition = true;
    // adjustFooterPadding()内でスクロール位置がリセットされる
    triggerFooterAdjustAfterTransition();
  });
})();

// 検索ドロワーの開閉アニメーション / メガメニュー制御の初期化
// @header-search.liquid
// 旧: 検索ドロワーを開いた時にヘッダーロゴを opacity:0 で隠していたが、
//     ロゴは常時表示する方針に変更したため当該処理を削除。
document.addEventListener("DOMContentLoaded", function () {
  // サーチドロワーの開閉アニメーション速度調整
  // @header-search.liquid
  // - 開く/閉じるともに「全体的に少しだけスロー」
  // - ちらつき防止のため、Promiseを返さず同期でanimationControlsを返す（vendor.timelineはtheme.liquidのmoduleでwindowへ渡す）
  function patchHeaderSearchDrawerAnimation() {
    if (window.__headerSearchDrawerAnimationPatched) {
      return;
    }

    const timeline = window.__vendor_timeline;
    if (typeof timeline !== "function") {
      // vendorのmodule読み込み待ち
      setTimeout(patchHeaderSearchDrawerAnimation, 50);
      return;
    }

    if (!window.customElements.get("x-drawer")) {
      window.customElements.whenDefined("x-drawer").then(patchHeaderSearchDrawerAnimation);
      return;
    }

    const Drawer = window.customElements.get("x-drawer");
    if (!Drawer) {
      return;
    }

    const OPEN_DURATION = 0.8; // 既存より少しだけスロー
    const CLOSE_DURATION = 0.4; // 既存(0.3s)より少しだけスロー

    const originalCreateEnterAnimationControls = Drawer.prototype.createEnterAnimationControls;
    const originalCreateLeaveAnimationControls = Drawer.prototype.createLeaveAnimationControls;

    Drawer.prototype.createEnterAnimationControls = function () {
      const isHeaderSearchDrawer = (this.classList && this.classList.contains("header-search-drawer")) || (typeof this.id === "string" && this.id.startsWith("header-search-"));

      if (!isHeaderSearchDrawer) {
        return originalCreateEnterAnimationControls.call(this);
      }

      const openFrom = this.openFrom || this.getAttribute("open-from") || "right";
      this.getShadowPartByName("content").style.marginInlineStart = openFrom === "right" ? "auto" : 0;

      const from = `translateX(calc(var(--transform-logical-flip) * ${openFrom === "right" ? "100%" : "-100%"}))`;

      // 1本のtransformアニメで最後までシームレスに
      return timeline([
        [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: OPEN_DURATION, easing: [0.25, 0.1, 0.25, 1] }],
        [this.getShadowPartByName("content"), { transform: [from, "translateX(0)"] }, { duration: OPEN_DURATION, at: "<", easing: [0.19, 1, 0.22, 1] }],
      ]);
    };

    Drawer.prototype.createLeaveAnimationControls = function () {
      const isHeaderSearchDrawer = (this.classList && this.classList.contains("header-search-drawer")) || (typeof this.id === "string" && this.id.startsWith("header-search-"));

      if (!isHeaderSearchDrawer) {
        return originalCreateLeaveAnimationControls.call(this);
      }

      const openFrom = this.openFrom || this.getAttribute("open-from") || "right";
      const to = `translateX(calc(var(--transform-logical-flip) * ${openFrom === "right" ? "100%" : "-100%"}))`;

      return timeline([
        [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: CLOSE_DURATION, easing: [0.25, 0.1, 0.25, 1] }],
        [this.getShadowPartByName("content"), { transform: ["translateX(0)", to] }, { duration: CLOSE_DURATION, at: "<", easing: [0.645, 0.045, 0.355, 1] }],
      ]);
    };

    window.__headerSearchDrawerAnimationPatched = true;
  }

  // メガメニューも通常ドロップダウンと同じ専用コントローラで扱う
  function patchMegaMenuAnimation() {
    if (typeof window.__initHeaderMenuDisclosureController === "function") {
      window.__initHeaderMenuDisclosureController();
    }
  }

  // 初期化
  patchHeaderSearchDrawerAnimation();
  patchMegaMenuAnimation();

  // 動的に追加される要素にも対応（検索ドロワーが追加された場合）
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // 検索ドロワーが追加された場合
          if ((node.classList && node.classList.contains("header-search-drawer")) || (node.id && node.id.startsWith("header-search-")) || (node.querySelector && (node.querySelector(".header-search-drawer") || node.querySelector("[id^='header-search-']")))) {
            setTimeout(function () {
              patchHeaderSearchDrawerAnimation();
            }, 100);
          }
        }
      });
    });
  });

  // 動的に追加される要素にも対応（検索ドロワーが追加された場合）
  observer.observe(document.body, { childList: true, subtree: true });
});

// ハンバーガーメニューを開く時、メニュー内リンクの下から上への個別アニメーションを無効化する。
// ドロワー本体の横スライドは theme.js / Drawer 側に残し、内部要素は開き始めから表示する。
(function () {
  "use strict";

  function cancelElementAnimations(element) {
    if (!element || typeof element.getAnimations !== "function") return;
    element.getAnimations().forEach(function (animation) { animation.cancel(); });
  }

  function setSidebarItemsVisible(sidebar) {
    if (!sidebar || !sidebar.querySelectorAll) return;

    var mainPanel = sidebar.querySelector(".header-sidebar__main-panel");
    var footer = sidebar.querySelector(".header-sidebar__footer");
    var animatedElements = Array.from(sidebar.querySelectorAll(".header-sidebar__main-panel .header-sidebar__linklist li"));

    if (mainPanel) {
      cancelElementAnimations(mainPanel);
      mainPanel.style.opacity = "1";
      mainPanel.style.transform = "translateX(0)";
    }

    animatedElements.forEach(function (element) {
      cancelElementAnimations(element);
      element.style.opacity = "1";
      element.style.transform = "none";
    });

    if (footer) {
      cancelElementAnimations(footer);
      footer.style.opacity = "1";
      footer.style.transform = "none";
    }
  }

  function patchHeaderSidebar() {
    var HeaderSidebar = window.customElements.get("header-sidebar");
    if (!HeaderSidebar || HeaderSidebar.prototype.__menuRevealDisabled === true) return;

    HeaderSidebar.prototype.revealItems = function () {
      setSidebarItemsVisible(this);

      return {
        finish: function () {},
        finished: Promise.resolve()
      };
    };

    HeaderSidebar.prototype.__menuRevealDisabled = true;
  }

  function bindSidebar(sidebar) {
    if (!sidebar || sidebar.dataset.menuRevealDisabledBound === "true") return;
    sidebar.dataset.menuRevealDisabledBound = "true";
    sidebar.addEventListener("dialog:before-show", function () {
      setSidebarItemsVisible(sidebar);
    });
  }

  function init() {
    patchHeaderSidebar();
    document.querySelectorAll("header-sidebar").forEach(bindSidebar);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches("header-sidebar")) bindSidebar(node);
          if (node.querySelectorAll) node.querySelectorAll("header-sidebar").forEach(bindSidebar);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (!window.customElements.get("header-sidebar")) {
    window.customElements.whenDefined("header-sidebar").then(init);
  } else if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// ハンバーガーメニュー内の検索ボタンで検索ドロワーを開く
// @header-sidebar.liquid / @header-search.liquid
// 検索ボタンは header-sidebar の Shadow DOM 内にあるため、検索ドロワー(x-drawer)が
// document.body に張る委譲クリックがイベントのリターゲットで拾えず、<a href> のまま
// 検索ページへ遷移してしまう。そこで composedPath() で検索ボタンのクリックを検知し、
//   1) 既存のハンバーガーサイドバー(#sidebar-menu)を閉じる
//   2) 検索専用ドロワー(#header-search-*)を開く
// を明示的に行う。検索ドロワーが無い環境では preventDefault せず href 遷移にフォールバック。
(function () {
  "use strict";

  document.addEventListener(
    "click",
    function (event) {
      const path = typeof event.composedPath === "function" ? event.composedPath() : [];

      let trigger = null;
      for (let i = 0; i < path.length; i++) {
        const node = path[i];
        if (node instanceof Element && node.matches("[data-header-sidebar-search]")) {
          trigger = node;
          break;
        }
      }
      if (!trigger) {
        return;
      }

      // 検索専用ドロワー（セクションIDが付くため前方一致で取得）
      const searchDrawer = document.querySelector('x-drawer[id^="header-search-"]');
      if (!searchDrawer || typeof searchDrawer.show !== "function") {
        // ドロワーが存在しない場合は通常の検索ページ遷移(href)に任せる
        return;
      }

      event.preventDefault();

      // 既存のハンバーガーサイドバーを閉じてから検索ドロワーを開く
      const sidebar = document.getElementById("sidebar-menu");
      if (sidebar && typeof sidebar.hide === "function") {
        sidebar.hide();
      }
      searchDrawer.show();
    },
    true
  );
})();

// フッターの言語リンク表示制御
// ※ 以前は <li> ベースの言語リスト前提で closest("li").style で現在言語を隠していたが、
//    言語切替を x-popover 化（footer.liquid の c-footer__language-selector）した際に
//    <li> 構造が無くなり、現在選択中（aria-selected="true"）の非表示は
//    custom.css の `.popover__value-option[aria-selected="true"] { display:none }`
//    で行うように移行済み。旧 JS は closest("li") が null になり TypeError を投げるため削除。

// フッターリンクブロックの外部リンクにtarget="_blank"を自動付与
// @footer.liquid (65-82)
// .footer__block--links内のaタグで外部リンクの場合にtarget="_blank"とrel="noopener noreferrer"を自動で付与
document.addEventListener("DOMContentLoaded", function () {
  /**
   * 外部リンクかどうかを判定する関数
   * @param {string} href - リンクのhref属性値
   * @returns {boolean} - 外部リンクの場合true
   */
  function isExternalLink(href) {
    if (!href) {
      return false;
    }

    // アンカーリンクやJavaScriptリンクは除外
    if (href.startsWith("#") || href.startsWith("javascript:") || href.startsWith("mailto:") || href.startsWith("tel:")) {
      return false;
    }

    // http://またはhttps://で始まる場合
    if (href.startsWith("http://") || href.startsWith("https://")) {
      try {
        const linkUrl = new URL(href);
        const currentUrl = new URL(window.location.href);
        // 現在のドメインと異なる場合は外部リンク
        return linkUrl.hostname !== currentUrl.hostname;
      } catch (e) {
        // URL解析エラーの場合は外部リンクとして扱う
        return true;
      }
    }

    // 相対パスの場合は内部リンク
    return false;
  }

  /**
   * フッターリンクブロック内の外部リンクにtarget="_blank"を付与する関数
   */
  function addTargetBlankToExternalLinks() {
    const footerLinkBlocks = document.querySelectorAll(".footer__block--links");

    footerLinkBlocks.forEach(function (block) {
      // 既に処理済みの場合はスキップ
      if (block.dataset.externalLinksProcessed === "true") {
        return;
      }
      block.dataset.externalLinksProcessed = "true";

      const links = block.querySelectorAll("a");

      links.forEach(function (link) {
        const href = link.getAttribute("href");

        if (isExternalLink(href)) {
          // 既にtarget="_blank"が設定されている場合はスキップ
          if (link.getAttribute("target") === "_blank") {
            return;
          }

          // target="_blank"を付与
          link.setAttribute("target", "_blank");

          // セキュリティのためrel="noopener noreferrer"も付与
          const currentRel = link.getAttribute("rel") || "";
          if (!currentRel.includes("noopener")) {
            link.setAttribute("rel", currentRel ? currentRel + " noopener noreferrer" : "noopener noreferrer");
          } else if (!currentRel.includes("noreferrer")) {
            link.setAttribute("rel", currentRel + " noreferrer");
          }
        }
      });
    });
  }

  // 初期化
  addTargetBlankToExternalLinks();

  // 動的に追加される要素にも対応
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // フッターリンクブロックが追加された場合
          if ((node.classList && node.classList.contains("footer__block--links")) || (node.querySelector && node.querySelector(".footer__block--links"))) {
            setTimeout(function () {
              addTargetBlankToExternalLinks();
            }, 100);
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

// フッターリンクブロック: プライバシーポリシーの下にクッキー設定を移動
// @footer.liquid
// プライバシーポリシーのリンクとクッキー設定が同じ.footer__block--links ul内に存在しているとき、
// プライバシーポリシーの下にクッキー設定要素を移動
(function () {
  "use strict";

  /**
   * プライバシーポリシーのリンクを検索する関数
   * @param {HTMLElement} ul - 検索対象のul要素
   * @returns {HTMLElement|null} - プライバシーポリシーのli要素
   */
  function findPrivacyPolicyLink(ul) {
    const links = ul.querySelectorAll("li a");
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      const href = link.getAttribute("href");
      const text = link.textContent.trim();
      // プライバシーポリシーのリンクを検索（hrefまたはテキストで判定）
      if ((href && href.includes("/policies/privacy-policy")) || text === "プライバシーポリシー" || text === "Privacy Policy") {
        return link.closest("li");
      }
    }
    return null;
  }

  /**
   * クッキー設定のリンクを検索する関数
   * @param {HTMLElement} ul - 検索対象のul要素
   * @returns {HTMLElement|null} - クッキー設定のli要素
   */
  function findCookieSettingsLink(ul) {
    const links = ul.querySelectorAll("li a");
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      const href = link.getAttribute("href");
      const text = link.textContent.trim();
      const onclick = link.getAttribute("onclick");
      // クッキー設定のリンクを検索（onclick属性またはテキストで判定）
      if ((onclick && onclick.includes("showPreferences")) || text === "クッキー設定" || text === "Cookie Settings") {
        return link.closest("li");
      }
    }
    return null;
  }

  /**
   * クッキー設定のリンクテキストを言語に応じて変更する関数
   * @param {HTMLElement} cookieSettingsLi - クッキー設定のli要素
   */
  function updateCookieSettingsText(cookieSettingsLi) {
    const link = cookieSettingsLi.querySelector("a");
    if (!link) {
      return;
    }

    // フッターの言語切替と同じ URL ベース判定（/ja 配下=日本語 / それ以外=英語）。
    // ※ 旧実装は <html lang> で判定していたが、/en を使わなくなった現行スキーム（/=英語・/ja=日本語）に合わせ、
    //   URL パスで判定して footer の言語切替と一致させる。
    const path = window.location.pathname;
    const isJapanese = path === "/ja" || path.indexOf("/ja/") === 0;

    link.textContent = isJapanese ? "クッキー設定" : "Cookie Settings";
  }

  /**
   * フッターリンクブロック内でプライバシーポリシーの下にクッキー設定を移動する関数
   * 注意: 要素は削除されず、位置のみが変更されます（DOM要素の移動）
   */
  function reorderFooterLinks() {
    const footerLinkBlocks = document.querySelectorAll(".footer__block--links");

    footerLinkBlocks.forEach(function (block) {
      const ul = block.querySelector("ul");
      if (!ul) {
        return;
      }

      const privacyPolicyLi = findPrivacyPolicyLink(ul);
      const cookieSettingsLi = findCookieSettingsLink(ul);

      // クッキー設定リンクが見つかれば、テキストは常に言語に合わせて更新する
      // （privacy policy の有無に依存しない）。
      if (cookieSettingsLi) {
        updateCookieSettingsText(cookieSettingsLi);
      }

      // 並び替え（プライバシーポリシーの直後へ移動）は両方が存在する場合のみ
      if (privacyPolicyLi && cookieSettingsLi) {
        // 既にプライバシーポリシーの直後にある場合はスキップ
        if (privacyPolicyLi.nextElementSibling === cookieSettingsLi) {
          return;
        }

        // クッキー設定をプライバシーポリシーの直後に移動（要素は削除されず、位置のみ変更）
        // insertAdjacentElementは要素を元の位置から削除して新しい位置に挿入するため、
        // 要素自体は削除されず、DOM内での位置のみが変更されます
        privacyPolicyLi.insertAdjacentElement("afterend", cookieSettingsLi);
      }
    });
  }

  // DOMContentLoaded時に実行
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(reorderFooterLinks, 100);
    });
  } else {
    setTimeout(reorderFooterLinks, 100);
  }

  // theme:loading:endイベントでも実行（Shopifyテーマのページ遷移後）
  document.addEventListener("theme:loading:end", function () {
    setTimeout(reorderFooterLinks, 100);
  });

  // 動的に追加される要素にも対応
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // フッターリンクブロックが追加された場合
          if ((node.classList && node.classList.contains("footer__block--links")) || (node.querySelector && node.querySelector(".footer__block--links"))) {
            setTimeout(function () {
              reorderFooterLinks();
            }, 100);
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// アナウンスメントバーの可視高さ(px)を追跡して、ドロワーのtop/height調整に使う
// - 全表示/半表示/非表示のどの状態でも「いま見えている高さ」だけオフセットする
(function () {
  const root = document.documentElement;
  const announcementBarSection = document.querySelector(".shopify-section--announcement-bar");

  // アナウンスメントバー自体が存在しない場合は0pxに固定
  if (!announcementBarSection) {
    root.style.setProperty("--announcement-bar-visible-height", "0px");
    return;
  }

  let rafId = null;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const update = () => {
    rafId = null;

    const rect = announcementBarSection.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    // viewport内に見えている縦方向の高さ(px)を計算
    const visible = clamp(Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0), 0, rect.height || 0);
    root.style.setProperty("--announcement-bar-visible-height", `${visible.toFixed(2)}px`);
  };

  const scheduleUpdate = () => {
    if (rafId != null) return;
    rafId = window.requestAnimationFrame(update);
  };

  window.addEventListener("scroll", scheduleUpdate, { passive: true });
  window.addEventListener("resize", scheduleUpdate);

  // 初期値を反映
  scheduleUpdate();
})();

// CartDrawer のアニメ override は削除：
// 真のサーチドロワー（<x-drawer class="header-search-drawer">）は
// Drawer 継承インスタンスでありデフォルトの duration 0.3 / easing
// cubic-bezier(0.645, 0.045, 0.355, 1) で動く。
// CartDrawer も Drawer 継承なので override しなければ同じ挙動になる。

// Pattern A のヘッダートーンを、ヘッダー背面にあるセクション設定から決定する
(function () {
  function initHeaderToneController() {
    const body = document.body;
    const main = document.getElementById("main");

    if (!body || !main || body.dataset.headerToneInitialized === "true") {
      return;
    }

    body.dataset.headerToneInitialized = "true";

    const VALID_TONES = ["light", "dark"];
    let rafId = null;

    function normalizeTone(tone) {
      return VALID_TONES.indexOf(tone) > -1 ? tone : "default";
    }

    function getDataTone(name) {
      const tone = normalizeTone(body.dataset[name]);

      return tone === "default" ? "" : tone;
    }

    function getDefaultTone() {
      return normalizeTone(body.dataset.headerDefaultTone) === "light" ? "light" : "dark";
    }

    function getProductTone(kind) {
      const specificTone = getDataTone(kind === "initial" ? "headerProductInitialTone" : "headerProductScrolledTone");

      return specificTone || getDataTone("headerProductTone");
    }

    function isAtInitialScrollPosition() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

      return scrollTop <= 1;
    }

    function isFooterSection(section) {
      return Boolean(section && (section.classList.contains("shopify-section--footer") || section.closest(".shopify-section--footer")));
    }

    function getHeaderRect() {
      const header = document.querySelector(".shopify-section--header .header");

      return header ? header.getBoundingClientRect() : null;
    }

    function isFooterTouchingHeader() {
      const headerRect = getHeaderRect();
      const footerSections = Array.from(main.querySelectorAll(".shopify-section--footer"));

      if (!headerRect || footerSections.length === 0) {
        return false;
      }

      return footerSections.some(function (footerSection) {
        const footerRect = footerSection.getBoundingClientRect();

        return footerRect.top <= headerRect.bottom && footerRect.bottom > headerRect.top;
      });
    }

    function getSelectedSlideTone(section, datasetKey) {
      const selectedSlide = section && section.querySelector(".slideshow__slide.is-selected[data-header-tone]");
      const tone = normalizeTone(selectedSlide && selectedSlide.dataset[datasetKey]);

      return tone === "default" ? "" : tone;
    }

    function getSectionTone(section, datasetKey) {
      const marker = section && section.querySelector(".c-section-header-tone[data-header-tone]");
      const tone = normalizeTone(marker && marker.dataset[datasetKey]);

      return tone === "default" ? "" : tone;
    }

    function resolveScrolledTone(section) {
      if (!section) {
        return getDefaultTone();
      }

      if (isFooterSection(section)) {
        return "dark";
      }

      const productTone = getProductTone("scrolled");

      if (productTone) {
        return productTone;
      }

      const selectedSlideTone = getSelectedSlideTone(section, "headerTone");
      if (selectedSlideTone) {
        return selectedSlideTone;
      }

      const tone = getSectionTone(section, "headerTone");

      return tone || getDefaultTone();
    }

    function resolveInitialTone(section) {
      if (!section) {
        return getDefaultTone();
      }

      if (isFooterSection(section)) {
        return "dark";
      }

      const productTone = getProductTone("initial");

      if (productTone) {
        return productTone;
      }

      const selectedSlideTone = getSelectedSlideTone(section, "headerInitialTone");
      if (selectedSlideTone) {
        return selectedSlideTone;
      }

      const tone = getSectionTone(section, "headerInitialTone");

      return tone || resolveScrolledTone(section);
    }

    function getProbeY() {
      const rect = getHeaderRect();

      if (!rect) {
        return 0;
      }

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

      return Math.min(Math.max(rect.top + rect.height / 2, 0), Math.max(viewportHeight - 1, 0));
    }

    function getCurrentSection() {
      const probeY = getProbeY();
      const sections = Array.from(main.querySelectorAll(".shopify-section"));
      let fallbackSection = null;

      for (const section of sections) {
        const rect = section.getBoundingClientRect();

        if (rect.height <= 0) {
          continue;
        }

        if (rect.top <= probeY && rect.bottom > probeY) {
          return section;
        }

        if (rect.top <= probeY) {
          fallbackSection = section;
        }
      }

      return fallbackSection || sections[0] || null;
    }

    function updateTone() {
      rafId = null;

      if (body.dataset.headerPattern !== "a") {
        body.dataset.headerTone = "dark";
        body.dataset.headerFooterActive = "false";
        return;
      }

      const section = getCurrentSection();
      const isFooterActive = isFooterTouchingHeader();

      body.dataset.headerFooterActive = isFooterActive ? "true" : "false";
      body.dataset.headerTone = isFooterActive
        ? "dark"
        : isAtInitialScrollPosition()
          ? resolveInitialTone(section)
          : resolveScrolledTone(section);
    }

    function scheduleUpdate() {
      if (rafId != null) {
        return;
      }

      rafId = window.requestAnimationFrame(updateTone);
    }

    function bindToneCarousels() {
      document.querySelectorAll("slideshow-carousel").forEach(function (carousel) {
        if (carousel.dataset.headerToneBound === "true") {
          return;
        }

        carousel.dataset.headerToneBound = "true";
        carousel.addEventListener("carousel:settle", scheduleUpdate);
      });
    }

    function refreshToneSources() {
      bindToneCarousels();
      scheduleUpdate();
    }

    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate);
    document.addEventListener("theme:loading:end", refreshToneSources);
    document.addEventListener("shopify:section:load", refreshToneSources);
    document.addEventListener("shopify:section:reorder", refreshToneSources);
    document.addEventListener("shopify:section:select", refreshToneSources);

    refreshToneSources();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeaderToneController);
  } else {
    initHeaderToneController();
  }
})();

/*
  custom: フッターの "Do Not Sell or Share My Personal Information" リンク文言を
          "Your Privacy Choices" に差し替え（リンク先 URL=href は変えない）。

          言語仕様（URL ベース）：
          - / （英語）: "Your Privacy Choices" に差し替える
          - /ja（日本語）: このリンクは en-only で非表示。LangShop の訳と競合させ
                          ないため英語ラベルを強制せず、DOM は触らない。

          Shopify のメニュー文言はテーマエディタ / 翻訳側で固定されているため、
          DOM 側で表示テキストだけ書き換える。
          shopify:section:load / theme:loading:end 等の再描画・遷移にも追従するよう
          MutationObserver とイベントで監視する。
*/
(function () {
  var TARGET_HREF_SUBSTRING = "do-not-sell-or-share-my-personal-information";
  var NEW_LABEL = "Your Privacy Choices";

  function isJapaneseUrl() {
    if (typeof window.isJapaneseUrl === "function") return window.isJapaneseUrl();
    var path = window.location.pathname;
    return path === "/ja" || path.indexOf("/ja/") === 0;
  }

  function relabel(root) {
    // 日本語 URL（/ja）では英語ラベルを強制しない（en-only で非表示・LangShop 訳優先）
    if (isJapaneseUrl()) return;

    var scope = root && typeof root.querySelectorAll === "function" ? root : document;
    var anchors = scope.querySelectorAll('a[href*="' + TARGET_HREF_SUBSTRING + '"]');
    anchors.forEach(function (a) {
      if (a.textContent.trim() === NEW_LABEL) return;
      a.textContent = NEW_LABEL;
    });
  }

  function init() {
    relabel(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node && node.nodeType === 1) {
            relabel(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Shopify テーマエディタでセクション再描画されたときも適用
    document.addEventListener("shopify:section:load", function () { relabel(document); });
    document.addEventListener("shopify:section:reorder", function () { relabel(document); });
    // SPA 的なページ遷移（LangShop の言語切替含む）後にも再適用
    document.addEventListener("theme:loading:end", function () { relabel(document); });
    window.addEventListener("popstate", function () { relabel(document); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// カート画面: Terms 同意チェックボックスで Checkout ボタンの有効/無効を切替
(function () {
  "use strict";

  function init() {
    var checkbox = document.querySelector(
      ".c-cart-summary__terms input[type='checkbox']"
    );
    var button = document.querySelector(".c-cart-checkout-button");
    if (!checkbox || !button) return;

    var update = function () {
      button.disabled = !checkbox.checked;
    };

    checkbox.addEventListener("change", update);
    update(); // 初期状態
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// FENDI 参考: 絞り込み / ハンバーガー内アコーディオンだけ、高さ開閉に寄せる。
// 中身自体はフェードや移動をさせず、親の高さだけでカーテン状に見せる。
(function () {
  "use strict";

  var HEIGHT_MS = 350;

  function clearAnims(els) {
    els.forEach(function (el) {
      if (!el || !el.getAnimations) return;
      el.getAnimations().forEach(function (a) {
        try { a.cancel(); } catch (e) {}
      });
    });
  }

  function settled(animations) {
    return Promise.all(animations.map(function (a) {
      return a.finished.catch(function () { return undefined; });
    })).then(function (results) {
      if (results.indexOf(undefined) !== -1) return undefined;
      return results[results.length - 1];
    });
  }

  function makeShowControls(self) {
    var details = self.disclosureElement;
    var summary = self.summaryElement;

    clearAnims([details]);
    details.style.overflow = "hidden";

    var heightAnim = details.animate(
      [{ height: summary.clientHeight + "px" }, { height: details.scrollHeight + "px" }],
      { duration: HEIGHT_MS, easing: "ease", fill: "forwards" }
    );

    var finished = settled([heightAnim]).then(function (last) {
      if (!last) return last;
      details.style.height = null;
      details.style.overflow = null;
      try { heightAnim.cancel(); } catch (e) {}
      return last;
    });

    return {
      finish: function () { heightAnim.finish(); },
      finished: finished
    };
  }

  function makeHideControls(self) {
    var details = self.disclosureElement;
    var summary = self.summaryElement;

    clearAnims([details]);
    details.style.overflow = "hidden";

    var heightAnim = details.animate(
      [{ height: details.clientHeight + "px" }, { height: summary.clientHeight + "px" }],
      { duration: HEIGHT_MS, easing: "ease", fill: "forwards" }
    );

    var finished = settled([heightAnim]).then(function (last) {
      if (!last) return last;
      setTimeout(function () {
        try { heightAnim.cancel(); } catch (e) {}
        details.style.overflow = null;
      }, 0);
      return last;
    });

    return {
      finish: function () { heightAnim.finish(); },
      finished: finished
    };
  }

  function isTarget(ad) {
    if (!ad || !ad.querySelector) return false;
    // FAQ も絞り込み（facets）と同じ高さのみアニメに揃える（content の opacity/translateY を廃止）。
    // 矢印回転は CSS（.icon.group-expanded:rotate の transition）で独立しているため影響しない。
    return Boolean(
      ad.closest(".facets-drawer") ||
      ad.closest(".shopify-section--faq") ||
      ad.querySelector("details.c-header-sidebar__accordion")
    );
  }

  function patch(ad) {
    if (!isTarget(ad) || ad.dataset.fendiAccordionPatched === "true") return;
    ad.dataset.fendiAccordionPatched = "true";

    ad.createShowAnimationControls = function () { return makeShowControls(this); };
    ad.createHideAnimationControls = function () { return makeHideControls(this); };
  }

  function patchAll(root) {
    (root || document).querySelectorAll("accordion-disclosure").forEach(patch);
  }

  function init() {
    patchAll();

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.tagName === "ACCORDION-DISCLOSURE") patch(node);
          if (node.querySelectorAll) patchAll(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// ハンバーガーメニュー内の検索ボタン押下時に、サイドバーを閉じてから検索ドロワーを開く。
// 既定ではサイドバーが開いたまま検索ドロワーも開いてしまうため。
(function () {
  "use strict";

  function bindSearchAction(sidebar) {
    if (!sidebar || sidebar.dataset.searchActionBound === "true") return;
    var searchAction = sidebar.querySelector(
      ".c-header-sidebar__actions a[aria-controls^='header-search-']"
    );
    if (!searchAction) return;
    sidebar.dataset.searchActionBound = "true";

    var targetId = searchAction.getAttribute("aria-controls");

    searchAction.addEventListener("click", function (event) {
      var searchDrawer = document.getElementById(targetId);
      if (!searchDrawer) return; // 既定のリンク遷移に委ねる

      event.preventDefault();
      // body へ delegate されている header-search の aria-controls ハンドラの発火を抑止
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }

      // 既に閉じている場合（万一）はそのまま開く
      if (!sidebar.hasAttribute("open")) {
        if (typeof searchDrawer.show === "function") searchDrawer.show();
        return;
      }

      function openSearch() {
        sidebar.removeEventListener("dialog:after-hide", openSearch);
        if (typeof searchDrawer.show === "function") searchDrawer.show();
      }
      sidebar.addEventListener("dialog:after-hide", openSearch);
      if (typeof sidebar.hide === "function") sidebar.hide();
    });
  }

  function init() {
    document.querySelectorAll("header-sidebar").forEach(bindSearchAction);

    // ヘッダーが Shopify セクションで再描画されたケースに備える
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.tagName === "HEADER-SIDEBAR") bindSearchAction(node);
          if (node.querySelectorAll) node.querySelectorAll("header-sidebar").forEach(bindSearchAction);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// コレクション/検索ページの「絞り込み(facet)」AJAX 更新後に
// theme.js が `.collection.scrollIntoView()` で先頭にスクロールするのを抑止し、
// 現在のスクロール位置のまま商品リストだけ差し替えるようにする。
// ※ ページネーションは facet:false（フルページ遷移）にしたため、ここの対象は絞り込みのみ。
//
// theme.js の facet:update ハンドラのフロー：
//   1. theme:loading:end を dispatch
//   2. shopifySection.replaceChildren(...)  ← 新しい .collection が DOM に乗る
//   3. requestIdleCallback(scrollToProductList)  ← .collection.scrollIntoView を予約
// theme:loading:end のリスナ内で queueMicrotask に登録すれば、
// ステップ 2 の同期処理が終わった後・ステップ 3 の idle コールバックが走る前に
// 新しい .collection の scrollIntoView を no-op に置き換えられる。
(function () {
  "use strict";

  function neutralizeScrollIntoView() {
    document.querySelectorAll(".collection").forEach(function (el) {
      if (el.__pageScrollPatched) return;
      el.__pageScrollPatched = true;
      el.scrollIntoView = function () {};
    });
  }

  function init() {
    neutralizeScrollIntoView();
    document.documentElement.addEventListener("theme:loading:end", function () {
      queueMicrotask(neutralizeScrollIntoView);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// 開閉アニメーション（theme.js Popover の opacity フェード等）を解除し、即時表示にする対象 popover。
// ・商品ページのバリエーション選択 (id="popover-variant-dropdown-...")
// ・フッターの通貨切替 (id="popover-currency-...")
// ・フッターの言語切替 (id="popover-language-...")
// PC(md) では Popover.createEnterAnimationControls が opacity:[0,1] を 0.2s で補間するためフェードする。
// x-popover の prototype を上書きし、対象 id のインスタンスだけ即時（duration 0 相当）にする。
// prototype 上書き＋呼び出し時に id 判定する方式（要素の生成/アップグレードのタイミングに依存しないため
// インスタンス上書きより堅牢）。対象外の popover は元の挙動のまま。
(function () {
  "use strict";

  // 即時化対象の id プレフィックス
  var INSTANT_POPOVER_PREFIXES = ["popover-variant-dropdown-", "popover-currency-", "popover-language-"];

  function isInstantPopover(el) {
    if (!el || !el.id) return false;
    return INSTANT_POPOVER_PREFIXES.some(function (p) {
      return el.id.indexOf(p) === 0;
    });
  }

  function setInstantPopoverState(el, isOpen) {
    var overlay = el.getShadowPartByName && el.getShadowPartByName("overlay");
    var content = el.getShadowPartByName && el.getShadowPartByName("content");

    el.style.opacity = isOpen ? "1" : "0";

    if (overlay) {
      overlay.style.opacity = isOpen ? "1" : "0";
    }

    if (content) {
      content.style.transform = "translateY(0)";
    }
  }

  function bindInstantPopoverLifecycle(el) {
    if (!isInstantPopover(el) || el.__instantPopoverLifecycleBound) return;
    el.__instantPopoverLifecycleBound = true;

    el.addEventListener("dialog:before-show", function () {
      el.style.setProperty("display", "block");
      setInstantPopoverState(el, true);
    });

    el.addEventListener("dialog:before-hide", function () {
      setInstantPopoverState(el, false);
      el.style.setProperty("display", "none");
    });
  }

  function instantControls(el, isOpen) {
    bindInstantPopoverLifecycle(el);
    setInstantPopoverState(el, isOpen);

    return {
      finish: function () {
        setInstantPopoverState(el, isOpen);
      },
      finished: Promise.resolve()
    };
  }

  function patchPrototype(PopoverClass) {
    if (!PopoverClass || !PopoverClass.prototype || PopoverClass.prototype.__instantPopoverPatched) return;
    PopoverClass.prototype.__instantPopoverPatched = true;

    var origEnter = PopoverClass.prototype.createEnterAnimationControls;
    var origLeave = PopoverClass.prototype.createLeaveAnimationControls;
    var origConnected = PopoverClass.prototype.connectedCallback;

    PopoverClass.prototype.connectedCallback = function () {
      origConnected.apply(this, arguments);
      bindInstantPopoverLifecycle(this);
    };

    PopoverClass.prototype.createEnterAnimationControls = function () {
      if (isInstantPopover(this)) {
        return instantControls(this, true);
      }
      return origEnter.apply(this, arguments);
    };
    PopoverClass.prototype.createLeaveAnimationControls = function () {
      if (isInstantPopover(this)) {
        return instantControls(this, false);
      }
      return origLeave.apply(this, arguments);
    };
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("x-popover").then(function () {
      patchPrototype(customElements.get("x-popover"));
      document.querySelectorAll("x-popover").forEach(bindInstantPopoverLifecycle);
    });
  }
})();

// related-products / recently-viewed-products カルーセル PC 限定：
// スライドを duration 300ms / CSS `ease`（cubic-bezier(0.25, 0.1, 0.25, 1)）で動かす。
// scroll-snap-type: x mandatory が効いていると JS で scrollLeft を弄っても snap が割り込んで暴れるため、
// アニメ中だけ CSS クラス + !important で snap を強制 none にする
// （theme.js の onScrollEnd_fn が inline style.scroll-snap-type を消しても影響を受けないように）。
(function () {
  "use strict";

  var SCOPE_SELECTOR = ".shopify-section--related-products scroll-carousel.product-list--carousel, .shopify-section--recently-viewed-products scroll-carousel.product-list--carousel";
  var DURATION_MS = 300;
  var PC_MIN_WIDTH = 1000;

  // CSS の "ease" は cubic-bezier(0.25, 0.1, 0.25, 1)。
  // Newton-Raphson で x（時間進捗）→ t（ベジエ媒介変数）→ y（出力進捗）を求める。
  function makeCubicBezier(x1, y1, x2, y2) {
    function bx(t) { return 3 * (1 - t) * (1 - t) * t * x1 + 3 * (1 - t) * t * t * x2 + t * t * t; }
    function by(t) { return 3 * (1 - t) * (1 - t) * t * y1 + 3 * (1 - t) * t * t * y2 + t * t * t; }
    function dbx(t) {
      return 3 * (1 - t) * (1 - t) * x1 + 6 * (1 - t) * t * (x2 - x1) + 3 * t * t * (1 - x2);
    }
    return function (x) {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      var t = x;
      for (var i = 0; i < 6; i++) {
        var slope = dbx(t);
        if (Math.abs(slope) < 1e-6) break;
        t -= (bx(t) - x) / slope;
        if (t < 0) t = 0; else if (t > 1) t = 1;
      }
      return by(t);
    };
  }
  var easeFn = makeCubicBezier(0.25, 0.1, 0.25, 1);

  function patchScrollTo(carousel) {
    if (!carousel || carousel.dataset.linearSlidePatched === "true") return;
    carousel.dataset.linearSlidePatched = "true";

    var nativeScrollTo = carousel.scrollTo.bind(carousel);
    var rafId = null;

    carousel.scrollTo = function (optsOrLeft) {
      if (window.innerWidth < PC_MIN_WIDTH) {
        return nativeScrollTo.apply(this, arguments);
      }
      var targetLeft, behavior;
      if (typeof optsOrLeft === "object" && optsOrLeft !== null) {
        targetLeft = optsOrLeft.left;
        behavior = optsOrLeft.behavior;
      } else {
        targetLeft = optsOrLeft;
      }
      if (behavior !== "smooth" || typeof targetLeft !== "number") {
        return nativeScrollTo.apply(this, arguments);
      }

      var startLeft = carousel.scrollLeft;
      var distance = targetLeft - startLeft;
      if (!distance) return;

      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }

      carousel.classList.add("c-linear-slide-active");

      var startTime = performance.now();
      function step(now) {
        var progress = Math.min((now - startTime) / DURATION_MS, 1);
        // CSS ease 相当のカーブを適用：開始ゆっくり → 中盤最速 → 終盤ゆっくり減速
        carousel.scrollLeft = startLeft + distance * easeFn(progress);
        if (progress < 1) {
          rafId = requestAnimationFrame(step);
        } else {
          rafId = null;
          carousel.classList.remove("c-linear-slide-active");
        }
      }
      rafId = requestAnimationFrame(step);
    };
  }

  function patchAll(root) {
    (root || document).querySelectorAll(SCOPE_SELECTOR).forEach(patchScrollTo);
  }

  function init() {
    patchAll();

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.querySelectorAll) patchAll(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// SP: blog のタグフィルター <select> を選択中の option の文字幅にフィットさせる。
// <select> の width は最長 option に固定されるため、CSS だけでは「現在の文字 + 9px + chevron」を
// 一塊として中央に置けない。JS で計測 → content-box width を設定。
// PC ではリセットして元のレイアウト（右寄せ）に戻す。
(function () {
  "use strict";

  var SP_QUERY = "(max-width: 999px)";

  function measureTextWidth(text, refEl) {
    var span = document.createElement("span");
    var style = window.getComputedStyle(refEl);
    span.style.position = "absolute";
    span.style.visibility = "hidden";
    span.style.whiteSpace = "nowrap";
    span.style.fontFamily = style.fontFamily;
    span.style.fontSize = style.fontSize;
    span.style.fontWeight = style.fontWeight;
    span.style.letterSpacing = style.letterSpacing;
    span.style.textTransform = style.textTransform;
    span.textContent = text;
    document.body.appendChild(span);
    var w = span.getBoundingClientRect().width;
    document.body.removeChild(span);
    return w;
  }

  /* `field-sizing: content` は Chrome/Edge 123+ で「フォーム要素を現在の値の幅に縮める」プロパティ。
     対応ブラウザでは CSS に任せ、JS で width を被せて中途半端な値で truncate するのを避ける。 */
  var supportsFieldSizing = window.CSS && CSS.supports && CSS.supports("field-sizing", "content");

  function syncSelectWidth(select) {
    if (!window.matchMedia(SP_QUERY).matches) {
      select.style.width = "";
      return;
    }
    if (supportsFieldSizing) {
      /* CSS の field-sizing: content に任せる。以前 JS で当てた width を解除 */
      select.style.width = "";
      return;
    }
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var w = measureTextWidth(opt.text, select);
    /* +6px：subpixel 丸め + form 要素特有のフォント差を吸収する安全マージン */
    select.style.width = Math.ceil(w + 6) + "px";
  }

  function init() {
    var selects = document.querySelectorAll(".shopify-section--main-blog .c-blog-tag-filter__select");
    if (!selects.length) return;
    selects.forEach(function (select) {
      syncSelectWidth(select);
      select.addEventListener("change", function () { syncSelectWidth(select); });
      window.addEventListener("resize", function () { syncSelectWidth(select); });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// 検索フォーム: クエリが空（空白のみ含む）の状態で Enter 送信されたとき、
// 空検索ページ(/search?q=)へ遷移してしまうのを防ぐ。検索フォームは name="q" の入力で判定。
// capture フェーズで他の submit ハンドラより先に握りつぶす。
(function () {
  "use strict";

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || typeof form.querySelector !== "function") return;

    // 検索フォーム以外（フィルタ・ニュースレター等）は対象外
    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    if (!input.value || !input.value.trim()) {
      event.preventDefault();
      event.stopPropagation();
      // 入力欄にフォーカスを残す（ドロワーは閉じない）
      try { input.focus(); } catch (e) {}
    }
  }, true);
})();

// 会員登録アプリ（Customer Fields）送信後の遷移先では、登録ページ上部の説明ブロックを非表示にする。
// クリックだけで即時非表示にせず、実際にページ遷移が始まった場合だけ次ページで反映する。
(function () {
  "use strict";

  var STORAGE_KEY = "anthings:hideRegisterIntroAfterCfSubmit";
  var SUBMIT_SELECTOR = ".shopify-section--main-customers-register .cf-submit-form";
  var TARGET_SELECTOR = ".customer-account-box .v-stack.gap-10";
  var shouldHideAfterNavigation = false;

  function markPendingNavigation(event) {
    var target = event.target;
    if (!target || typeof target.closest !== "function") return;
    if (target.closest(SUBMIT_SELECTOR)) {
      shouldHideAfterNavigation = true;
      return;
    }

    if (event.type === "submit" && typeof target.querySelector === "function" && target.querySelector(SUBMIT_SELECTOR)) {
      shouldHideAfterNavigation = true;
    }
  }

  function hideTargetBlocks() {
    var targets = document.querySelectorAll(TARGET_SELECTOR);
    if (!targets.length) return false;

    targets.forEach(function (target) {
      target.style.display = "none";
    });
    return true;
  }

  function initHideAfterNavigation() {
    try {
      if (!window.sessionStorage || sessionStorage.getItem(STORAGE_KEY) !== "1") return;
    } catch (e) {
      return;
    }

    if (hideTargetBlocks()) {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      return;
    }

    var observer = new MutationObserver(function () {
      if (hideTargetBlocks()) {
        observer.disconnect();
        try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(function () {
      observer.disconnect();
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
    }, 5000);
  }

  document.addEventListener("click", markPendingNavigation, true);
  document.addEventListener("submit", markPendingNavigation, true);

  window.addEventListener("pagehide", function () {
    if (!shouldHideAfterNavigation) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch (e) {}
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHideAfterNavigation);
  } else {
    initHideAfterNavigation();
  }
})();
